"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AnnouncementsCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const Theme_1 = require("../Theme");
const Announcements_1 = __importDefault(require("../api/Announcements"));
const UserContext_1 = require("../contexts/UserContext");
const Loading_1 = __importDefault(require("../components/Loading"));
const react_i18next_1 = require("react-i18next");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Button_1 = __importDefault(require("../components/Button"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        container: {
            backgroundColor: THEME.CardBackground,
            borderColor: THEME.CardBorder,
            borderRadius: 4,
            borderWidth: 1,
            borderBottomWidth: 2
        }
    });
};
function AnnouncementsCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const isDark = (0, ThemeContext_1.useIsDark)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('loading');
    const [timerDisabled, setTimerDisabled] = react_1.default.useState(false);
    const [currentIndex, setCurrentIndex] = react_1.default.useState(0);
    const [announcements, setAnnouncements] = react_1.default.useState([]);
    const [isTruncated, setIsTruncated] = react_1.default.useState(false);
    const fadeAnimation = react_1.default.useRef(new react_native_1.Animated.Value(1)).current;
    const announcementContainerRef = react_1.default.useRef(null);
    const refresh = () => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => {
            Announcements_1.default.getAnnouncementsForEmployee(token)
                .then((data) => {
                setAnnouncements(data);
                setStatus('done');
            });
        })
            .catch(() => {
            setStatus('error');
        }));
    };
    // Animate the fade in and out of the announcement changing
    react_1.default.useEffect(() => {
        const slideInterval = setInterval(() => {
            if (announcements?.length > 1 && !timerDisabled) {
                react_native_1.Animated.timing(fadeAnimation, {
                    toValue: 0,
                    duration: 400,
                    useNativeDriver: false,
                }).start(() => {
                    if (currentIndex + 1 == announcements.length)
                        setCurrentIndex(0);
                    else
                        setCurrentIndex(currentIndex + 1);
                    react_native_1.Animated.timing(fadeAnimation, {
                        toValue: 1,
                        duration: 400,
                        useNativeDriver: false,
                    }).start();
                });
            }
        }, 8000);
        return () => {
            clearInterval(slideInterval);
        };
    }, [announcements, currentIndex, timerDisabled]);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
        };
    }, []);
    const goBack = () => {
        setCurrentIndex(currentIndex == 0 ? announcements.length - 1 : currentIndex - 1);
        setTimerDisabled(true);
    };
    const goForward = () => {
        setCurrentIndex(currentIndex + 1 == announcements.length ? 0 : currentIndex + 1);
        setTimerDisabled(true);
    };
    const selectedAnnouncement = announcements?.[currentIndex];
    react_1.default.useEffect(() => {
        if (announcementContainerRef.current) {
            const node = announcementContainerRef.current;
            if (node.getBoundingClientRect) {
                const rect = node.getBoundingClientRect();
                setIsTruncated(rect.height >= 85);
            }
        }
    }, [selectedAnnouncement?.body]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (announcements == null || announcements.length > 0)
            &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.container, columns > 1 ? STYLES.cardLandscape : STYLES.cardPortait, { marginTop: 12, padding: 12, paddingTop: 0 }], children: (status == 'done' && ((0, jsx_runtime_1.jsx)(react_native_1.View, { children: (!announcements || announcements.length == 0 || !selectedAnnouncement)
                            ||
                                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 12, backgroundColor: THEME.SoftGray, borderRadius: 4 }, children: (0, jsx_runtime_1.jsxs)(FadeInView_1.default, { style: [{ flex: 1, opacity: fadeAnimation, overflow: 'hidden' }], children: [(0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { "aria-label": t('common:buttons.readMore'), disabled: !isTruncated, style: { paddingHorizontal: 6 }, onPress: () => props.navigation.navigate("AnnouncementView", { id: selectedAnnouncement.id }), children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 12 }, children: [!!selectedAnnouncement.title && (0, jsx_runtime_1.jsx)(react_native_1.Text, { numberOfLines: 1, ellipsizeMode: "tail", style: { color: THEME.Text, fontSize: 14, fontWeight: '500' }, children: selectedAnnouncement.title }), !!selectedAnnouncement.body &&
                                                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { position: 'relative', height: 84 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { numberOfLines: 6, ellipsizeMode: "tail", style: {
                                                                                    color: THEME.Text,
                                                                                    fontSize: 12,
                                                                                    marginTop: 6,
                                                                                    lineHeight: 14,
                                                                                    height: 84,
                                                                                    position: 'relative',
                                                                                }, children: selectedAnnouncement.body }), (0, jsx_runtime_1.jsx)(react_native_1.View, { pointerEvents: isTruncated ? 'auto' : 'none', style: {
                                                                                    display: isTruncated ? 'flex' : 'none',
                                                                                    position: 'absolute',
                                                                                    left: 0,
                                                                                    right: 0,
                                                                                    bottom: 0,
                                                                                    height: 50,
                                                                                    zIndex: 2,
                                                                                    marginBottom: -12,
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'flex-end',
                                                                                    //@ts-ignore
                                                                                    background: `linear-gradient(to top, ${THEME.SoftGray} 10%, rgba(249,249,249,0) 100%)`,
                                                                                }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                                                        textAlign: 'center',
                                                                                        color: THEME.Primary,
                                                                                        backgroundColor: THEME.PrimaryLightest,
                                                                                        borderWidth: 1,
                                                                                        borderRadius: 8,
                                                                                        borderColor: THEME.PrimaryLight,
                                                                                        padding: 8,
                                                                                        fontSize: 14,
                                                                                        marginBottom: 8,
                                                                                        lineHeight: 14,
                                                                                        fontWeight: '500',
                                                                                        userSelect: 'none'
                                                                                    }, children: t('common:buttons.readMore') }) })] }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { ref: announcementContainerRef, style: {
                                                                            position: 'absolute',
                                                                            height: 'auto',
                                                                            width: '100%',
                                                                            opacity: 0,
                                                                            fontSize: 12,
                                                                            marginTop: 6,
                                                                            lineHeight: 14,
                                                                            pointerEvents: 'none',
                                                                            zIndex: -1,
                                                                        }, children: selectedAnnouncement.body })] })] }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'stretch', backgroundColor: THEME.SmokeWhite, paddingVertical: 4, borderBottomLeftRadius: 4, borderBottomRightRadius: 4, paddingHorizontal: 6 }, children: [(0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('help:hints.prevAnnouncement'), type: 'borderless', disabled: !(announcements?.length > 1), style: { paddingLeft: 12, paddingRight: 24 }, onPress: () => goBack(), children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { size: 16, icon: Theme_1.ICONS.Solid.ChevronLeft, style: { color: !(announcements?.length > 1) ? THEME.TextDisabled : (isDark ? THEME.Primary : THEME.PrimaryDark) } }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, flexDirection: 'row', alignItems: 'center' }, children: !!selectedAnnouncement.actionTitle &&
                                                            (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginLeft: 4 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: 'solid', text: selectedAnnouncement.actionTitle, color: THEME.Primary, textSize: 14, numberOfLines: 1, ellipsizeMode: 'tail', onPress: () => react_native_1.Linking.openURL(selectedAnnouncement.actionUrl) }) }) }), (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('help:hints.nextAnnouncement'), type: 'borderless', disabled: !(announcements?.length > 1), style: { paddingLeft: 24, paddingRight: 12 }, onPress: () => goForward(), children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { size: 16, icon: Theme_1.ICONS.Solid.ChevronRight, style: { color: !(announcements?.length > 1) ? THEME.TextDisabled : (isDark ? THEME.Primary : THEME.PrimaryDark) } }) })] })] }) }) })))
                        ||
                            (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }) })
            ||
                (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) }));
}
